export enum AuctionStatusType {
    Open = 1,
    Closed = 2,
    Archived = 3,
    Processed = 4,
}
